/**
 * Utility function to wait until the DOM content is fully loaded.
 *
 * @returns {Promise<void>} A promise that resolves when the DOM content is loaded.
 */
export default function waitForDomContentLoaded(): Promise<void> {
    return new Promise(resolve => {
        if (document.readyState === 'complete' || document.readyState === 'interactive') {
            requestAnimationFrame(() => resolve());
        } else {
            document.addEventListener('DOMContentLoaded', () => resolve(), { once: true });
        }
    });
}